module.exports = __webpack_public_path__ + "img/qualityManagement_sign.a5d17889.png";